import React from "react";
import PropTypes from "prop-types";

import { questionTypeConstants } from "../../../constants";
import TextBox from "../questionTypes/textBox";
import StarRanking from "../questionTypes/starRanking";

/**
 * Renders a single survey question editor (star ranking or textbox) inside the DnD list.
 */
const SurveyQuestionListItem = ({
  question,
  index,
  dragHandleProps,
  errors,
  register,
  resetField,
  localRole,
  questionList,
  setIsChanges,
  setQuestionList,
  handleSurveySubmit,
  handleRecipientsUser,
  handleRemoveQuestion,
  deletedSecondarySurveyQuestions,
  setDeletedSecondarySurveyQuestions,
  questionsAnswerArray,
}) => {
  const questionTypeId = Number(question?.questionTypeId);
  const displayIndex = index + 1;

  if (questionTypeId === questionTypeConstants.STAR_RANKING_ID) {
    return (
      <StarRanking
        handle={dragHandleProps}
        question={question}
        errors={errors}
        index={displayIndex}
        register={register}
        localRole={localRole}
        questionList={questionList}
        setIsChanges={setIsChanges}
        setQuestionList={setQuestionList}
        handleSurveySubmit={handleSurveySubmit}
        handleRecipientsUser={handleRecipientsUser}
        handleRemoveQuestion={handleRemoveQuestion}
      />
    );
  }

  if (questionTypeId === questionTypeConstants.TEXTBOX_ID) {
    return (
      <TextBox
        handle={dragHandleProps}
        errors={errors}
        index={displayIndex}
        register={register}
        question={question}
        localRole={localRole}
        resetField={resetField}
        questionList={questionList}
        setIsChanges={setIsChanges}
        setQuestionList={setQuestionList}
        handleSurveySubmit={handleSurveySubmit}
        deletedSecondarySurveyQuestions={deletedSecondarySurveyQuestions}
        setDeletedSecondarySurveyQuestions={setDeletedSecondarySurveyQuestions}
        handleRecipientsUser={handleRecipientsUser}
        questionsAnswerArray={questionsAnswerArray}
        handleRemoveQuestion={handleRemoveQuestion}
      />
    );
  }

  return null;
};

SurveyQuestionListItem.propTypes = {
  question: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  dragHandleProps: PropTypes.object,
  errors: PropTypes.object,
  register: PropTypes.func,
  resetField: PropTypes.func,
  localRole: PropTypes.bool,
  questionList: PropTypes.array,
  setIsChanges: PropTypes.func,
  setQuestionList: PropTypes.func,
  handleSurveySubmit: PropTypes.func,
  handleRecipientsUser: PropTypes.func,
  handleRemoveQuestion: PropTypes.func,
  deletedSecondarySurveyQuestions: PropTypes.array,
  setDeletedSecondarySurveyQuestions: PropTypes.func,
  questionsAnswerArray: PropTypes.array,
};

export default SurveyQuestionListItem;
